import styled from 'styled-components';
import { usePatternContext } from '../../../../../context/PatternContext';
import { DataProps } from './data';
import { s } from './ResultReport.styles';

interface Props {
  data: DataProps[];
}

const Summary = ({ data }: Props) => {
  const { patternInfo } = usePatternContext();
  const FormatText = (grade: number) => {
    if (grade === 1) {
      return <span style={{ color: '#F45551' }}>매우낮음</span>;
    } else if (grade === 2) {
      return <span style={{ color: '#FF9524' }}>낮음</span>;
    } else if (grade === 3) {
      return <span style={{ color: '#09AB49' }}>보통</span>;
    } else if (grade === 4) {
      return <span style={{ color: '#34ADFF' }}>높음</span>;
    } else {
      return <span style={{ color: '#008AFF' }}>매우높음</span>;
    }
  };
  const FormatColor = (grade: number) => {
    if (grade === 1) {
      return { background: '#F45551' };
    } else if (grade === 2) {
      return { background: '#FF9524' };
    } else if (grade === 3) {
      return { background: '#09AB49' };
    } else if (grade === 4) {
      return { background: '#34ADFF' };
    } else {
      return { background: '#008AFF' };
    }
  };
  const gradeText = (grade: number) => {
    if (grade === 1) {
      return <span style={{ color: '#F45551' }}>요주의</span>;
    } else if (grade === 2) {
      return <span style={{ color: '#FF9524' }}>보통</span>;
    } else if (grade === 3) {
      return <span style={{ color: '#09AB49' }}>우수</span>;
    } else {
      return <span style={{ color: '#008AFF' }}>매우높음</span>;
    }
  };

  return (
    <s.SummaryBox style={{ backgroundColor: '#fff' }}>
      <Inner>
        <s.BlockTitle>알고리즘 분석 결과</s.BlockTitle>
        <ContentWrapper>
          {data.length > 0 &&
            data.slice(0, 3).map((item, index) => (
              <ContentBox>
                <ContentTitleBox>
                  <div>
                    {index === 0
                      ? '전체물건'
                      : index === 1
                        ? '수익(Win)물건'
                        : '손실(Lose)물건'}{' '}
                    {gradeText(item.grade)}
                  </div>
                  <div>
                    <span style={{ fontSize: '12px' }}>
                      경매건수{' '}
                      {Number(
                        index === 0
                          ? data[0].total_cnt
                          : index === 1
                            ? data[0].success_cnt
                            : Number(data[0].total_cnt) -
                              Number(data[0].success_cnt),
                      ).toLocaleString()}
                      건
                    </span>
                  </div>
                </ContentTitleBox>
                <GraphWrapper>
                  <GraphBox>
                    <GraphTitleBox>
                      <div>안전성</div>
                      {FormatText(item.safety)}
                    </GraphTitleBox>
                    <s.ContentCell width="100%">
                      <s.RowItemInner style={{ padding: 0 }}>
                        <s.GradeBox
                          style={{ background: '#70737C14', height: '4px' }}
                        >
                          <s.Bar
                            grade={item.safety}
                            style={FormatColor(item.safety)}
                          ></s.Bar>
                        </s.GradeBox>
                      </s.RowItemInner>
                    </s.ContentCell>
                  </GraphBox>
                  <GraphBox>
                    <GraphTitleBox>
                      <div>시세차익가능성</div>
                      {FormatText(item.profit_possibility)}
                    </GraphTitleBox>
                    <s.ContentCell width="100%">
                      <s.RowItemInner style={{ padding: 0 }}>
                        <s.GradeBox
                          style={{ background: '#70737C14', height: '4px' }}
                        >
                          <s.Bar
                            grade={item.profit_possibility}
                            style={FormatColor(item.profit_possibility)}
                          ></s.Bar>
                        </s.GradeBox>
                      </s.RowItemInner>
                    </s.ContentCell>
                  </GraphBox>
                  <GraphBox>
                    <GraphTitleBox>
                      <div>수익성</div>
                      {FormatText(item.profitability)}
                    </GraphTitleBox>
                    <s.ContentCell width="100%">
                      <s.RowItemInner style={{ padding: 0 }}>
                        <s.GradeBox
                          style={{ background: '#70737C14', height: '4px' }}
                        >
                          <s.Bar
                            grade={item.profitability}
                            style={FormatColor(item.profitability)}
                          ></s.Bar>
                        </s.GradeBox>
                      </s.RowItemInner>
                    </s.ContentCell>
                  </GraphBox>
                </GraphWrapper>
              </ContentBox>
            ))}
        </ContentWrapper>
      </Inner>
    </s.SummaryBox>
  );
};

export default Summary;

const GraphTitleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  span {
    font-size: 13px;
  }
`;

const GraphBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const GraphWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e5e8ea;
  background-color: #fafafb;
`;

const ContentTitleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 20.3px;
  word-wrap: break-word;
  span {
    color: #616161;
    font-size: 14px;
    font-weight: 500;
    line-height: 17.4px;
  }
`;

const ContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px 16px 40px;
`;
